module.exports = __webpack_public_path__ + "img/dataempty.a4575533.png";